import { respond } from "theme/styles/mixins";

export default `
  .project-thumb-placeholder {
    &--mobile {
      ${respond(`display: none;`, 75)}
    }

    &--desktop {
      display: none;
      ${respond(`display: block;`, 75)}
    }

    &--primary {
      .project-thumb-placeholder__tile {
        fill: var(--color-accent-primary-extra-pale);
      }
    }

    &--secondary {
      .project-thumb-placeholder__tile {
        fill: var(--color-base-neutral10);
      }
    }

    &--tertiary {
      .project-thumb-placeholder__tile {
        fill: var(--color-base-blue20);
      }
    }

    &--quaternary {
      .project-thumb-placeholder__tile {
        fill: var(--color-base-orange20);
      }
    }

    &--quinary {
      .project-thumb-placeholder__tile {
        fill: var(--color-base-violet20);
      }
    }

    &--outlined {
      .project-thumb-placeholder__tile {
        fill: transparent;
      }

      .project-thumb-placeholder__illustration {
        .backend &,
        .project-hero--dark & {
          stroke: var(--color-base-neutral50);
        }
      }
    }

    &__tile {
      fill: var(--color-base-neutral-white);
    }

    &__illustration {
      stroke: var(--color-base-neutral75);

      .backend &,
      .project-hero--dark & {
        stroke: var(--color-base-neutral90);
      }
    }

    &__frame {
      stroke: var(--color-base-neutral75);

      .backend &,
      .project-hero--dark & {
        stroke: var(--color-base-neutral50);
      }
    }

    &__icon {
      position: absolute;
      inline-size: 32px;
      block-size: auto;
      top: calc((var(--Avatar-width) - 6px) * .5);
      left: calc((var(--Avatar-width) - 6px) * .5);
      fill: var(--color-base-neutral75);
      transform: translate(-50%, -50%);
      
      ${respond(
        `
        top: 58px;
        left: 58px;
        inline-size: 60px;
        transform: translate(-50%, -50%);
      `,
        75
      )}

      .project-hero--dark & {
        fill: var(--color-base-neutral90);
      }
    }
  }
`;
